import { getMainDefinition } from '@apollo/client/utilities';
import type { DocumentNode, OperationVariables } from '@apollo/client';

export function getPrecacheOperationKey(
  query: DocumentNode,
  variables?: OperationVariables
): string {
  return (getMainDefinition(query).name?.value ?? 'unnamed-query') + JSON.stringify(variables);
}
